var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-cascader", {
    ref: _vm.refs,
    attrs: {
      placeholder: "请选择",
      "popper-class": _vm.refs,
      disabled: _vm.disabled,
      options: _vm.datas,
      props: _vm.props,
      "show-all-levels": _vm.showAllLevels,
      clearable: _vm.clearable
    },
    on: {
      "visible-change": _vm.visibleChange,
      "expand-change": _vm.visibleChange,
      change: _vm.checkChange
    },
    model: {
      value: _vm.ids,
      callback: function($$v) {
        _vm.ids = $$v
      },
      expression: "ids"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f4be343c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f4be343c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegionTree.vue
// module id = 533
// module chunks = 14